import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PUT 完整取代角色權限。必帶角色目前的 record.updated_at（與 PATCH 共用版本）。
 * @see docs/API_SYSTEM_ACCESS.md
 */
export async function replaceRolePermissions(roleId, permissionIds, updatedAt) {
  const { data: raw } = await request.put(
    `/system/role/${roleId}/permissions`,
    keysToSnake({ permissionIds: permissionIds ?? [], updatedAt }),
  );
  return parseVer4DetailResponse(raw);
}
